import { removeHTMLTags } from 'shared/utils';

export const hasReporterOnlyNotesChanged = (
  prevNotes: string | null,
  newNotes: string,
): boolean => {
  const prev = (prevNotes ?? '').trim();
  const next = newNotes.trim();

  if (!prev || !next) {
    return prev !== next;
  }

  return removeHTMLTags(prev) !== removeHTMLTags(next);
};
